export const resolveColor = (inputColor) => {
  if (!inputColor) return undefined;
  const tokenToHex = {
    'primary-500': '#7F0689',
    'secondary-500': '#75D3A8',
  };
  return tokenToHex[inputColor] || inputColor;
};



